import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BookingModal from "./components/BookingModal";
import WhatsAppChat from "./components/WhatsAppChat";
import Seo from "./components/Seo";
import "./App.css";

const local_server = 'http://localhost:3001';
const main_server = 'https://salon-admin.deyfreshsignature.com';
axios.defaults.baseURL = main_server;
axios.defaults.withCredentials = true;

function App() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [bookingService, setBookingService] = useState("");
  const toggleBooking = (service = "") => {
    if (!isBookingOpen) setBookingService(typeof service === "string" ? service : "");
    setIsBookingOpen(!isBookingOpen);
  };

  return (
    <Router>
      <div className="app-wrapper">
        <Seo />
        <Navbar onBookClick={toggleBooking} />
        <Routes>
          <Route path="/" element={<Home onBookClick={toggleBooking} />} />
          <Route path="/about" element={<About onBookClick={toggleBooking} />} />
          <Route path="/services" element={<Services onBookClick={toggleBooking} />} />
          <Route path="/gallery" element={<Gallery onBookClick={toggleBooking} />} />
          <Route path="/contact" element={<Contact onBookClick={toggleBooking} />} />
        </Routes>
        <Footer onBookClick={toggleBooking} />
        <WhatsAppChat />
        {isBookingOpen && <BookingModal onClose={() => toggleBooking("")} initialService={bookingService} />}
      </div>
    </Router>
  );
}

export default App;